/**
 * Fetches a file from a URL and triggers a browser download.
 * Forces a fresh CORS request (cache: 'no-cache') to avoid serving a stale
 * non-CORS-cached response from a prior <video> preload request.
 */
export const downloadFile = async (
  url: string,
  filename: string,
): Promise<void> => {
  const response = await fetch(url, { mode: "cors", cache: "no-cache" });
  if (!response.ok) throw new Error(`Server returned ${response.status}`);

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};

/** Builds a safe filename from an optional title, a fallback id, and an extension. */
export const buildDownloadFilename = (
  title: string | undefined,
  id: number,
  ext: string,
): string =>
  title
    ? `${title.replace(/[^a-z0-9]/gi, "_").toLowerCase()}.${ext}`
    : `file_${id}.${ext}`;
